import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { Spinner } from '@phoenix/design-system/frontend/ui/spinner/spinner';
import { cx } from '@emotion/css';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { useTranslation } from 'next-i18next';
import { cn } from '@phoenix/design-system/frontend/util/classNameUtils';

export type DealerPreferencesChipProps = { isLoading: boolean } & React.HTMLAttributes<HTMLDivElement> & {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
    editable?: boolean;
    isMainDealer?: boolean;
    dealerDescription?: string;
  };
export const DealerPreferencesChip = ({
  onClick,
  isLoading,
  children,
  className,
  editable = false,
  isMainDealer = false,
  dealerDescription,
  ...rest
}: DealerPreferencesChipProps) => {
  const { t } = useTranslation(['shared']);
  return (
    <div
      className={cx(
        'inline-flex max-h-8 items-center space-x-1 self-start whitespace-nowrap rounded-full py-1 stihl-text-body-default-bold',
        editable ? 'pl-4 pr-[3px]' : 'px-4',
        className
      )}
      {...rest}
    >
      <span>{children}</span>
      {editable && (
        <span>
          {!isLoading && (
            <button
              type="button"
              onClick={(event) => {
                event?.stopPropagation();
                event?.nativeEvent.stopImmediatePropagation();
                onClick(event);
              }}
              className={cn(
                'flex h-6 w-6 items-center justify-center overflow-hidden rounded-full hover:bg-primary-white/30 transition-colors duration-200',
                'focus-visible:outline-offset-[-1px] focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline'
              )}
              aria-haspopup="dialog"
            >
              <PhoenixIcon className="flex-0 h-3 w-3 text-current" icon={getDesignSystemIcon('icon-cross-16.svg')} />
              <span className="sr-only">
                {isMainDealer
                  ? t('shared_dealers_map_list_chip_myDealer_remove_aria', {
                      dealer: dealerDescription,
                    })
                  : t('shared_dealers_map_list_chip_fav_remove_aria', {
                      dealer: dealerDescription,
                    })}
              </span>
            </button>
          )}
          {isLoading && (
            <span className="flex h-6 w-6 items-center justify-center">
              <Spinner className="h-4 w-4 rounded-half border-[0.15rem] border-secondary-mid/40 border-l-primary-white text-[0.625rem] after:w-4" />
            </span>
          )}
        </span>
      )}
    </div>
  );
};
